import { QQuikIdentity } from './lib/identity';

export { QQuikIdentity };
export default QQuikIdentity;

// If you need these types later, uncomment and implement:
// export type { ApiConfig, ApiResponse } from './types/types';
